<div class="text-center py-3" *ngIf="loading">
  <i class="fas fa-spinner fa-pulse fa-2x"></i>
</div>
<div *ngIf="!loading">
  <div class="row mb-2">
    <div class="col-10 offset-1">
      <a href="javascript: void(0)" class="btn btn-link btn-sm" (click)="showNewUserForm = !showNewUserForm"> <i [class]="'fa fa-' + (showNewUserForm ? 'minus' : 'plus') + '-circle'"></i>&nbsp;New Matter User </a>
      <app-matter-user-form *ngIf="showNewUserForm" [matter_id]="matter_id" (formResult)="formResult($event)"></app-matter-user-form>
    </div>
  </div>
  <table class="table" style="font-size: 80%">
    <tbody>
      <tr *ngFor="let matter_user of matter_users">
        <th scope="row" style="width: 32%" *ngIf="!matter_user.editing">{{ matter_user.matter_user_type_name }}</th>
        <td style="width: 25%" *ngIf="!matter_user.editing">
          <a *ngIf="allowedToViewUserIncome" [routerLink]="'/matter_users/' + matter_user.id + '/user_income'">{{ matter_user.display_name }}</a>
          <span *ngIf="!allowedToViewUserIncome">{{ matter_user.display_name }}</span>
        </td>
        <td style="width: 15.5%" *ngIf="!matter_user.editing">
          <span [style.opacity]="!matter_user.is_active ? '1' : '0'" class="text-danger"><i class="fas fa-minus-circle"></i></span>
          <span [style.opacity]="matter_user.include_in_all_notifications ? '1' : '0'" class="text-success"><i class="fas fa-check"></i></span>
        </td>
        <td style="width: 27.5%" *ngIf="!matter_user.editing">
          <button title="Edit matter user" [disabled]="matter_user.deleting" (click)="editMatterUser(matter_user)" tooltip="Edit matter user" type="button" style="cursor: pointer" class="btn btn-outline-primary btn-sm"><i class="fas fa-pencil-alt"></i></button>
          <button title="Remove matter user" (click)="confirmMatterUserDelete(matter_user, deleteModal)" [disabled]="matter_user.deleting" tooltip="Remove matter user" type="button" style="cursor: pointer" class="btn btn-outline-danger btn-sm"><i class="fas fa-minus-circle"></i></button>
        </td>
        <td colspan="4" *ngIf="matter_user.editing">
          <div class="font-italic mb-2 text-info">Editing Matter User</div>
          <div class="row">
            <div class="col-10 offset-1">
              <app-matter-user-form [matter_user_id]="matter_user.id" (formResult)="formResult($event, matter_user)"></app-matter-user-form>
            </div>
          </div>
        </td>
      </tr>
      <tr>
        <td colspan="4">
          <label class="form-check-label">
            <input class="form-check-input" type="checkbox" [(ngModel)]="search_params.showInactive" (change)="loadMatterUsers()" />
            Show Inactive Users
          </label>
        </td>
      </tr>
    </tbody>
  </table>
</div>
<ng-template #deleteModal let-c="close" let-d="dismiss">
  <!--<div class="modal-header">
    	<h4 class="modal-title">Modal title</h4>
    	<button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
    		<span aria-hidden="true">&times;</span>
    	</button>
  	</div>-->
  <div class="modal-body">
    <p>Remove matter user - {{ matterUserToBeDeleted ? matterUserToBeDeleted.display_name : '' }} ?</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-danger" (click)="c('Delete')">Confirm delete</button>
    <button type="button" class="btn btn-secondary" (click)="d('Cancel')">Cancel</button>
  </div>
</ng-template>
